import { defineMessages } from 'react-intl';

export default defineMessages({
  selected: {
    id: 'ReactFilters.messages.boolean.selected',
    defaultMessage: 'Selected',
  },
  notSelected: {
    id: 'ReactFilters.messages.boolean.notSelected',
    defaultMessage: 'Not selected',
  },
});
